import React, { useEffect, useState } from "react";
import PlayPreviewButton from "../../../../components/PlayPreviewButton";
import BaseModal from "../../../../components/modals/BaseModal";

const ChooseVoiceModal = ({ onClose, onSubmit, dataFromSnippet, show }) => {
  const [selectedVoice, setSelectedVoice] = useState(null);
  const agentLanguage = dataFromSnippet.agentLanguage || "en-US";
  const voices = dataFromSnippet.voices;

  useEffect(() => {
    setSelectedVoice(dataFromSnippet.selectedVoice);
  }, [dataFromSnippet]);

  const onSubmitInternal = () => {
    const voiceObject = voices.find((voice) => voice.id === selectedVoice);

    const message = {
      action: "choose-receptionist",
      voiceObject: voiceObject,
    };
    onSubmit(message);
    onClose();
  };

  const headerChildren = (
    <div className="flex items-center justify-between w-full">
      <h2 className="text-lg font-bold">Choose Your Receptionist</h2>
    </div>
  );

  const bodyChildren = (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-3 gap-4">
        {voices.map((voice) => {
          return (
            <div
              onClick={() => setSelectedVoice(voice.id)}
              key={voice.id}
              className={`flex p-1 flex-col cursor-pointer justify-between items-center rounded-md space-y-2 ${
                selectedVoice === voice.id ? "" : "md:hover:bg-slate-200"
              } ${selectedVoice === voice.id ? "bg-slate-300" : ""}`}
            >
              <div className="flex flex-col items-center">
                <img src={voice.image} alt="" className="h-8 md:h-20 object-cover" />
                <span className="text-sm">{voice.name}</span>
              </div>
              <PlayPreviewButton
                voice={voice.id}
                textToPlay={voice.introductionSentence}
                audioPath={voice.audioPath}
                id={`receptionist-preview-button-${voice.id}`}
                iconSize="size-8"
                disabled={voice?.enablePreview === false}
                language={voice.language || agentLanguage}
              />
            </div>
          );
        })}
      </div>
      <button
        className="bg-primary px-4 py-2 text-white font-semibold hover:opacity-80"
        onClick={onSubmitInternal}
      >
        Submit
      </button>
    </div>
  );

  return (
    <BaseModal
      headerChildren={headerChildren}
      bodyChildren={bodyChildren}
      onClose={onClose}
      width="w-5/6 md:4/6 lg:w-1/2"
      height="w-1/2"
      show={show}
    />
  );
};

export default ChooseVoiceModal;
